export const SET_TASK_FILTERS = 'SET_TASK_FILTERS';

export const RESET_TASK_FILTERS = 'RESET_TASK_FILTERS';

export const SET_TASK_GRID_SORT_CRITERIA = 'SET_TASK_GRID_SORT_CRITERIA';
